import forOwn from 'lodash/forOwn';
import has from 'lodash/has';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import isObject from 'lodash/isObject';

export function deepDifference<TResult>(obj1, obj2) {
  const result = {} as TResult;

  forOwn(obj1, (value, key) => {
    if (isObject(value) && isObject(obj2[key])) {
      const diff = deepDifference(value, obj2[key]);
      if (!isEmpty(diff)) {
        result[key] = diff;
      }
    } else if (!isEqual(value, obj2[key])) {
      result[key] = value;
    }
  });

  forOwn(obj2, (value, key) => {
    if (!has(obj1, key)) {
      result[key] = value;
    }
  });

  return result;
}
